import { SimpleSelect } from 'lib/ui';

export function Select({ input, data }) {
  return <SimpleSelect {...input} {...data} />;
}
